import * as React from "react";

function SvgDownload({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M21 16.25a.75.75 0 01.75.75 4.75 4.75 0 01-4.533 4.745L17 21.75H7A4.75 4.75 0 012.25 17a.75.75 0 011.5 0 3.25 3.25 0 003.066 3.245L7 20.25h10A3.25 3.25 0 0020.25 17a.75.75 0 01.75-.75zm-9.061 1.499l.061.001a.731.731 0 01-.178-.02l-.03-.01a.41.41 0 01-.068-.021c-.01-.006-.02-.01-.03-.014a.462.462 0 01-.067-.033l-.021-.014a.432.432 0 01-.053-.034l-.084-.073-5-5a.75.75 0 01.976-1.134l.084.073 3.721 3.721V3a.75.75 0 011.493-.102L12.75 3v12.187l3.72-3.717a.75.75 0 01.976-.073l.084.073a.75.75 0 01.073.976l-.073.084-5 5a.756.756 0 01-.08.07l.08-.069a.725.725 0 01-.124.1c-.017.01-.035.021-.053.03-.012.008-.025.014-.037.02a.687.687 0 01-.068.027l-.036.012a.845.845 0 01-.076.018l-.032.006a.869.869 0 01-.104.006l-.061-.001z"
        />
      </g>
    </svg>
  );
}

export default SvgDownload;
